import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import api from "../lib/api";
import Login from "./Login";
import AdminLayout from "./AdminLayout";
import Leads from "./Leads";
import ProjectsAdmin from "./ProjectsAdmin";
import ReviewsAdmin from "./ReviewsAdmin";
import BlogAdmin from "./BlogAdmin";
import SettingsAdmin from "./SettingsAdmin";

export default function AdminApp() {
  const [status, setStatus] = useState("checking"); // checking | in | out

  const check = () => {
    api
      .get("/auth/me")
      .then(() => setStatus("in"))
      .catch(() => setStatus("out"));
  };

  useEffect(() => {
    check();
  }, []);

  if (status === "checking") {
    return <div className="min-h-screen bg-[#0b0e13] flex items-center justify-center text-[#6b7683]">Loading...</div>;
  }

  if (status === "out") {
    return (
      <Routes>
        <Route path="*" element={<Login onLogin={() => setStatus("in")} />} />
      </Routes>
    );
  }

  return (
    <AdminLayout>
      <Routes>
        <Route index element={<Navigate to="/admin/leads" replace />} />
        <Route path="leads" element={<Leads />} />
        <Route path="projects" element={<ProjectsAdmin />} />
        <Route path="reviews" element={<ReviewsAdmin />} />
        <Route path="blog" element={<BlogAdmin />} />
        <Route path="settings" element={<SettingsAdmin />} />
        <Route path="*" element={<Navigate to="/admin/leads" replace />} />
      </Routes>
    </AdminLayout>
  );
}
